module.exports = __webpack_public_path__ + "img/ECFD12F1-E0CD-4B30-8343-B7DFE836218B.4e1a17aa.png";